import { DateTime } from "luxon";

export class JobListPresenter {
  constructor(count, appointments) {
    const newAppointments = appointments.map(item => ({
        id: item.id.toString(),
        dateTime: DateTime.fromISO(item.date_time).toUTC(),
        dateTimeEnd: item.date_time_end
          ? DateTime.fromISO(item.date_time_end).toUTC()
          : null,
        status: item.status,
        service: {
          id: item.service.id.toString(),
          name: item.service.name
        },
        provider: {
          name: item.provider.name
        },
        home: {
          address: `${item.home.address_no}, ${item.project.name}`,
          contact: {
            name: `${item.user.first_name} ${item.user.last_name}`,
            phoneNumber: item.user.mobile_number || "-"
          }
        },
        route: {
          name: "SupplierJobDetail",
          params: { appointmentId: item.id }
        },
        createdAt: DateTime.fromISO(item.created_at).toUTC(),
        note: item.note || "-",
        appointmentNo: item.appointment_no,
        quantity: item.quantity
      }));

    this.count = count;
    this.appointments = newAppointments;
  }
}
